module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/ahdMGs/tc-custom/9780544816251.jpg?1705839756367",
      "alt": "This image is the cover for the book Fresh from the Freezer, Betty Crocker Cooking"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Fresh from the Freezer, Betty Crocker Cooking\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("Unlock the frozen asset in your kitchen with these quick and easy make-ahead recipes the whole family will love.")]), _c('br'), _c('br'), _vm._v(" Freezing is the easy way to guarantee that fresh, must-have recipes are always ready when you are. From freeze-ahead smoothie cubes to Monkey Bread, Chicken Pot Pie and mug cakes, this handy book lets you cook when you can, and eat when you want. 150 fully tested recipes give you the best ideas for cooking and freezing—prepare do-ahead dishes to freeze, cook foods to be the base of multiple meals, make slow cooker dinners, and more.")]), _c('br'), _vm._v(" Included is everything for Freezing 101—complete freezing, thawing and heating information, tips on storage options and advice on how long to freeze foods. The book covers the rules of the thaw, how to host a Freezer Meal Party, and how to use ice cube trays to freeze herbs, chocolate-dipped fruit—and even wine. This is the complete guide to turning the freezer into a make-ahead star.\n    "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Betty Crocker\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("For 100 years now, Betty Crocker has been the name Americans trust most to level the culinary playing field with innovative new ways to make delicious simple through reliably tasty and intuitive kitchen solutions. With more than 75 million cookbooks sold since 1950, Betty Crocker continues to connect with makers everywhere.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Houghton Mifflin Harcourt Publishing Company\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0